/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM, TOP } from 'Component/ChevronIcon/ChevronIcon.config';
import ClickOutside from 'Component/ClickOutside';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import Loader from 'Component/Loader';
import SearchIcon from 'Component/SearchIcon';
import { RefType } from 'Type/Common.type';
import { FieldOptionsType } from 'Type/Field.type';
import { OrdersType, OrderType } from 'Type/Order.type';
import { convertStringToDate } from 'Util/Manipulations/Date';
import { formatPrice } from 'Util/Price';

import './NewIssueForm.style';

/** @namespace PeggysagePwa/Component/NewIssueForm/Component */
export class NewIssueFormComponent extends PureComponent {
    static propTypes = {
        onCreateSubmitSuccess: PropTypes.func.isRequired,
        orders: OrdersType.isRequired,
        subjectOptionsList: FieldOptionsType.isRequired,
        selectedOrder: OrderType.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isLoadingOrders: PropTypes.bool.isRequired,
        isOrderFieldVisible: PropTypes.bool.isRequired,
        isOrderSearchVisible: PropTypes.bool.isRequired,
        inputAutocompleteRef: RefType.isRequired,
        onSubjectFieldChange: PropTypes.func.isRequired,
        onOrderFieldFocus: PropTypes.func.isRequired,
        closeOrderSearch: PropTypes.func.isRequired,
        onOrderIsSelected: PropTypes.func.isRequired,
        onOrderSearchInputChange: PropTypes.func.isRequired,
        onFileButtonClick: PropTypes.func.isRequired,
        numberInputFile: PropTypes.number.isRequired
    };

    renderSubjectField() {
        const { subjectOptionsList, onSubjectFieldChange } = this.props;

        return (
            <fieldset block="NewIssueForm" elem="Legend">
                <Field
                  type={ FIELD_TYPE.select }
                  label={ __('Objet de ma demande') }
                  attr={ {
                      id: 'subject',
                      name: 'subject',
                      noPlaceholder: true
                      // selectPlaceholder: '...'
                  } }
                  options={ subjectOptionsList }
                  events={ {
                      onChange: onSubjectFieldChange
                  } }
                  addRequiredTag
                  validationRule={ {
                      isRequired: true
                  } }
                  validateOn={ ['onChange'] }
                  mix={ { block: 'NewIssueForm', elem: 'SelectField' } }
                />
            </fieldset>
        );
    }

    renderOrderSearch() {
        const { isOrderSearchVisible, onOrderSearchInputChange, inputAutocompleteRef } = this.props;

        return (
            <div block="NewIssueForm" elem="SearchWrapper" mods={ { isVisible: isOrderSearchVisible } }>
                <div block="NewIssueForm" elem="SearchInputWrapper">
                    <input
                      block="NewIssueForm"
                      elem="SearchInput"
                      placeholder={ __('Rechercher un numéro de commande') }
                      onChange={ onOrderSearchInputChange }
                      ref={ inputAutocompleteRef }
                    />
                    <SearchIcon />
                </div>
                { this.renderOrderList() }
            </div>
        );
    }

    renderOrderField() {
        const {
            isOrderFieldVisible,
            isOrderSearchVisible,
            selectedOrder: {
                id: selectedOrderId = '',
                increment_id: selectedOrderIncrementId = ''
            },
            onOrderFieldFocus,
            closeOrderSearch
        } = this.props;

        if (!isOrderFieldVisible) {
            return null;
        }

        return (
            <ClickOutside onClick={ closeOrderSearch }>
                <fieldset block="NewIssueForm" elem="Legend">
                    <div block="NewIssueForm" elem="OrderFieldGroup">
                        <div block="NewIssueForm" elem="OrderFieldWrapper">
                            <Field
                              type={ FIELD_TYPE.text }
                              label={ __('Numéro de ma commande') }
                              attr={ {
                                  id: 'order_increment_id',
                                  name: 'order_increment_id',
                                  defaultValue: selectedOrderIncrementId,
                                  onClick: onOrderFieldFocus,
                                  onFocus: onOrderFieldFocus,
                                  placeholder: `${__('Numéro de ma commande')} *`,
                                  readOnly: 'readonly'
                              } }
                              readOnly
                              mix={ {
                                  block: 'NewIssueForm',
                                  elem: 'OrderField',
                                  mods: { isExpanded: isOrderSearchVisible }
                              } }
                              validationRule={ {
                                  isRequired: true
                              } }
                              validationResponse={ null }
                              addRequiredTag
                            />
                            <input
                              type="hidden"
                              name="order_id"
                              id="order_id"
                              value={ selectedOrderId }
                              readOnly="readonly"
                            />
                            <ChevronIcon direction={ isOrderSearchVisible ? TOP : BOTTOM } />
                        </div>
                        { this.renderOrderSearch() }
                    </div>
                </fieldset>
            </ClickOutside>
        );
    }

    renderMessageField() {
        return (
            <fieldset block="NewIssueForm" elem="Legend">
                <Field
                  type={ FIELD_TYPE.textarea }
                  label={ __('Décrire ma demande') }
                  mix={ { block: 'NewIssueForm', elem: 'TextArea' } }
                  attr={ {
                      placeholder: `${__('Décrire ma demande')} *`,
                      id: 'message',
                      name: 'message'
                  } }
                  addRequiredTag
                  validationRule={ {
                      isRequired: true
                  } }
                />
            </fieldset>
        );
    }

    renderFileField() {
        const { onFileButtonClick, numberInputFile } = this.props;

        return (
            <fieldset block="NewIssueForm" elem="Legend">
                <div block="NewIssueForm" elem="FileField">
                    { Array.from({ length: numberInputFile }, (_, index) => (
                        <Field
                          type={ FIELD_TYPE.file }
                          attr={ {
                              name: `file_${ index }`,
                              id: `file_${ index }`,
                              accept: 'image/jpg,image/jpeg,image/png,application/pdf'
                          } }
                          key={ index }
                        />
                    )) }
                    <div block="NewIssueForm" elem="FileActions">
                        <button
                          type="button"
                          block="Button"
                          mods={ { likeLink: true } }
                          mix={ { block: 'NewIssueForm', elem: 'FileButton' } }
                          onClick={ onFileButtonClick }
                        >
                            { __('Ajouter un fichier') }
                        </button>
                        <span block="NewIssueForm" elem="FileSpecs">
                            { __('(optionnel - pdf, jpg / 3Mo max)') }
                        </span>
                    </div>
                </div>
            </fieldset>
        );
    }

    renderSubmitButton() {
        return (
            <div block="NewIssueForm" elem="Actions">
                <button type="submit" block="Button">
                    { __('Envoyer ma demande') }
                </button>
            </div>
        );
    }

    renderForm() {
        const { onCreateSubmitSuccess } = this.props;

        return (
            <Form
              key="new-issue"
              mix={ { block: 'NewIssueForm', elem: 'Form' } }
              onSubmit={ onCreateSubmitSuccess }
            >
                { this.renderSubjectField() }
                { this.renderOrderField() }
                { this.renderMessageField() }
                { this.renderFileField() }
                { this.renderSubmitButton() }
            </Form>
        );
    }

    renderOrderItem(order) {
        const { onOrderIsSelected } = this.props;
        const {
            id,
            increment_id,
            order_date,
            total: {
                grand_total: {
                    value: orderTotal,
                    currency
                }
            },
            status
        } = order;

        const dateFormatted = convertStringToDate(order_date);
        const priceFormatted = formatPrice(orderTotal, currency);

        return (
            <div block="NewIssueForm" elem="Order" key={ id }>
                <button
                  type="button"
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={ () => onOrderIsSelected(order) }
                >
                    <span block="NewIssueForm" elem="OrderId">
                        { __('N°%s', increment_id) }
                    </span>
                    <span block="NewIssueForm" elem="OrderDate">
                        { dateFormatted }
                    </span>
                    <span block="NewIssueForm" elem="OrderPrice">
                        { `(${priceFormatted})` }
                    </span>
                    <span block="NewIssueForm" elem="OrderStatus">
                        { status }
                    </span>
                </button>
            </div>
        );
    }

    renderOrderList() {
        const { orders, isLoadingOrders } = this.props;

        if (!isLoadingOrders && (!orders || !orders.length)) {
            return null;
        }

        // Sort orders by date DESC
        orders.sort((a, b) => b.increment_id - a.increment_id);

        return (
            <div block="NewIssueForm" elem="OrderList">
                <Loader isLoading={ isLoadingOrders } />
                { orders.map(this.renderOrderItem.bind(this)) }
            </div>
        );
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div block="NewIssueForm">
                { this.renderForm() }
                <Loader isLoading={ isLoading } />
            </div>
        );
    }
}

export default NewIssueFormComponent;
